import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-autorizar-patron-fraude',
  templateUrl: './autorizar-patron-fraude.component.html',
  styleUrls: ['./autorizar-patron-fraude.component.scss'],
})
export class AutorizarPatronFraudeComponent implements OnInit {
  form: FormGroup = this.fb.group({
    autorizar: ['', Validators.required],
    patron_fraude: ['', Validators.required],
  });
  constructor(public fb: FormBuilder) {}

  ngOnInit() {}
}
